import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { Observable, Subscription } from 'rxjs';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { ToastrService } from 'ngx-toastr';
import _ from 'lodash';
import {
  CasiProjectUser,
  Project, User as UserModel
} from '../../models/models.lib';
import { LoggerService } from '../../shared/logger.service';
import { UserStoryOwnerService } from '../../tracker/user-story-owner.service';

@Component({
  selector: 'casi-project-user-selection',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    RouterLink,
    RouterLinkActive,
    GridModule,
    InputsModule,
    ButtonsModule
  ],
  templateUrl: './project-user-selection.component.html',
  styleUrl: './project-user-selection.component.scss'
})
export class ProjectUserSelectionComponent implements OnInit, OnDestroy {

  @Input({ required: true }) project: Project = new Project(1);
  @Input({ required: true }) users: CasiProjectUser[] = [];
  @Input({ required: true }) projectUsers: CasiProjectUser[] = [];

  @Output() onCancel = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<CasiProjectUser[]>();

  public view: Observable<CasiProjectUser[]> = new Observable<CasiProjectUser[]>();
  public rawData: CasiProjectUser[] = [];
  public filter: CompositeFilterDescriptor = { logic: "and", filters: [] };
  public gridData: CasiProjectUser[] = []; // filterBy(this.rawData, this.filter);

  @ViewChild("appendTo", { read: ViewContainerRef }) appendTo: ViewContainerRef | undefined;

  private _subs: Subscription[] = [];
  private _selectedUsers: number[] = [];
  public toggleFlag: boolean = false;

  constructor(
    private logger: LoggerService,
    private toastr: ToastrService,
    private dataService: UserStoryOwnerService
  ) {
  }

  //#region NG Event Handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...', this.project);
    // this._selectedUsers = (this.projectUsers.map(pu => pu.user_id) as number[]);
    this.initialGrid();
    // this.dataService.query((this.project.id as number));
    // this._subs.push(this.dataService.subscribe(rp => {
    //   // this.logger.debug('ngOnInit:rp: ', rp);
    //   this.rawData = rp;
    //   this.gridData = this.handleDataInit(rp);// filterBy(this.rawData, this.filter);
    // }));

  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnInit...');
    this._subs.forEach(s => s.unsubscribe());
  }

  //#endregion

  closeWindow(): void {
    this.logger.debug(`closeWindow...`);
    this.onCancel.emit();
  }

  closeAndSaveWindow(): void {
    this.logger.debug(`closeAndSaveWindow...`);
    this.handleSave()
  }

  toggleAll(): void {
    this.logger.debug('toggleAll...');
    this.toggleFlag = !this.toggleFlag;
    this.toggleAllUsers(this.toggleFlag);
  };

  setSelection(dataItem: CasiProjectUser) {
    this.logger.debug('setSelection:dataItem: ', dataItem);
    dataItem.selected = !dataItem.selected;
    // const { id } = dataItem;
    // if (!dataItem.selected) {
    //   dataItem.selected = true;
    //   if (this._selectedUsers.indexOf(id) === -1) {
    //     this._selectedUsers.push(id);
    //   }
    // }
    // else {
    //   dataItem.selected = false;
    //   if (this._selectedUsers.indexOf(id) != - -1) {
    //     this._selectedUsers.splice(this._selectedUsers.indexOf(id), 1);
    //   }
    // }

    this.logger.debug(`selected items`, {
      dataItem
    });
  };

  private initialGrid(): void {
    this.logger.debug(`initialGrid...`, this.users);
    this.gridData.length = 0;
    this.users.forEach(u => {
      let found = this.projectUsers.find(pu => pu.user_id === u.user_id);
      this.logger.debug(`initialGrid:found: `, found);
      if (found) {
        found.selected = true;
        u.selected = true;
        this.toggleFlag = true;
      }
      this.gridData = this.users;
    })

  }
  private toggleAllUsers(flag: boolean = false): void {
    this.logger.debug('toggleAllUsers...');
    this.gridData.forEach(gd => gd.selected = flag);
    // this._selectedUsers = this.gridData.filter(f => f.selected === true).map(gd => gd.user_id);
    // this.logger.debug('toggleAllUsers...', this._selectedUsers);
  };


  private handleSave() {

    this.logger.debug(`handleSave: gridData: `, this.gridData);
    this.onSave.emit(this.gridData.filter(f => f.selected === true))
    // return this.dataService
    //   .update((this.role.id as number), this._selectedUsers)
    //   .then((done) => {
    //     this.toastr.success('Role Permissions Updated');
    //     this.onSave.emit();
    //   })
    //   .catch(err => {
    //     this.toastr.error('Problem updating permissions');
    //     this.logger.error(`handleSave: ** ERROR **`, err);
    //   });
  }

}
